import { useState, useEffect } from "react";
import Layout from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    toast.success("Thank you — we'll respond shortly.");
    setForm({ name: "", email: "", subject: "", message: "" });
  };
  return (
    <Layout>
      <section className="container-msis py-16">
        <div className="overline mb-3">Contact</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter">Get in touch.</h1>
        <div className="grid lg:grid-cols-2 gap-12 mt-12">
          <form onSubmit={submit} className="space-y-4 max-w-xl" data-testid="contact-form">
            <Input data-testid="contact-name" placeholder="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
            <Input data-testid="contact-email" type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
            <Input data-testid="contact-subject" placeholder="Subject" value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} required />
            <Textarea data-testid="contact-message" placeholder="Message" rows={6} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} required />
            <button type="submit" className="btn-primary" data-testid="contact-submit">Send Message</button>
          </form>
          <aside className="space-y-3">
            <div className="card-grid"><div className="overline">Email</div><div className="font-mono mt-1" data-testid="contact-email-display">{settings.contact_email || "msisreports@gmail.com"}</div></div>
            <div className="card-grid"><div className="overline">Phone</div><a href={`tel:${(settings.contact_phone || "+91 9703368234").replace(/\s/g, "")}`} className="font-mono mt-1 block hover:text-navy" data-testid="contact-phone-display">{settings.contact_phone || "+91 9703368234"}</a></div>
            <div className="card-grid"><div className="overline">Institutional Sales</div><div className="font-mono mt-1">{settings.contact_email || "msisreports@gmail.com"}</div></div>
            <div className="card-grid"><div className="overline">Hours</div><div className="text-sm mt-1">Mon–Fri · 10:00 – 18:00 IST</div></div>
          </aside>
        </div>
      </section>
    </Layout>
  );
}
